module.exports = __webpack_public_path__ + "media/images/social/tiktok-1261116a9fef344121f16256ecdb4bd8.png";